import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { MemberDto } from '@pokerroom/types';
import { api } from '../../lib/api';
import { memberCardTokenFromQr } from './memberCardQr';

export default function MemberCardScanPage() {
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    const token = memberCardTokenFromQr(window.location.href, window.location.origin);
    window.history.replaceState(window.history.state, '', '/members/scan');
    if (!token) {
      setError(true);
      return;
    }
    let cancelled = false;
    void api
      .post<MemberDto>('/members/portal-card/resolve', { token })
      .then((member) => {
        if (!cancelled) navigate(`/members/${member.id}`, { replace: true });
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <section className="rounded-lg border border-base-300 bg-base-100 p-4" role="status">
      {error ? '辨識碼無效或已過期，請會員重新出示。' : '正在辨識會員…'}
    </section>
  );
}
